/* eslint-disable @typescript-eslint/no-explicit-any */
export function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
export function merge(target, ...sources) {
    if (!sources.length)
        return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, { [key]: {} });
                merge(target[key], source[key]);
            }
            else {
                Object.assign(target, { [key]: source[key] });
            }
        });
    }
    return merge(target, ...sources);
}
export function cloneDeep(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Map) {
        return new Map(Array.from(obj, ([key, value]) => [key, cloneDeep(value)]));
    }
    const clone = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            clone[key] = cloneDeep(obj[key]);
        }
    });
    return clone;
}
//# sourceMappingURL=lightDash.js.map